<template>
  <div id="trades">
    <rich-text v-if="page" :elements="page.document.content" :is-root="true"></rich-text>
  </div>
</template>

<script>
import RichText from '@/components/RichText.vue';

export default {
  name: 'trades',
  props: ['page'],
  components: {
    RichText,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang='sass'>
  #trades
    .introduction
      position: relative
      margin-bottom: 5rem
      padding: 3rem 0 3.5rem
      background: linear-gradient(to right, white 0%, white 30%, #ecf1f4 30%, #ecf1f4 100%)
      .column:first-child
        text-align: right
      h2
        position: relative
        display: inline-block
        margin-right: 8rem
        &::after
          content: ""
          position: absolute
          right: 0
          bottom: -1rem
          display: block
          height: 4px
          width: 1500px
          background-color: #fe3904

    .jobs
      padding: 0 0 4rem 0
      .columns
        display: block
        > .grid
          margin: 3rem 0
          &:nth-child(odd) .rich-text
            position: relative
            flex-flow: row-reverse
            .element:first-child
              padding: 0 0 0 5rem
          &:nth-child(even) .rich-text
            position: relative
            &:after
              content: ""
              position: absolute
              left: 40%
              top: 0
              bottom: 0
              width: 150%
              background: #ecf1f4
              z-index: -1

      .rich-text
        display: flex
        align-items: center
        justify-content: space-between
        .element:first-child
          flex: 1 0 65%
          padding: 0 5rem 0 0
        img
          margin: 1rem 0
          width: 300px
        b
          position: relative
          display: block
          margin-bottom: 3rem
          color: #fe3904
          text-transform: uppercase
          font-size: 2rem
          font-weight: 600
          &::after
            content: ""
            position: absolute
            left: 0
            bottom: -1rem
            display: block
            height: 4px
            width: 60px
            background-color: #fe3904

    .numbers-list
      padding: 0 0 4rem 0
      .columns
        flex-wrap: wrap
        > .column
          width: 50%
          flex: auto
          counter-increment: number
          .rich-text
            position: relative
            padding: 1rem 0 1rem 4rem
            &::before
              content: counter(number)
              position: absolute
              left: 0
              top: 50%
              display: flex
              margin: -15px 0 0 0
              width: 30px
              height: 30px
              justify-content: center
              align-items: center
              color: #ffffff
              background-color: #fe3904

    .expertise
      .title
        color: #fe3904
      .columns
        .column
          position: relative
          display: flex
          padding: 3rem 0 !important
          flex-direction: column
          justify-content: center
        p
          width: 70%
        &:nth-child(even) .column:first-child
          figure
            padding: 0
            margin: 1rem 0 3rem auto
            height: 4px
            width: 5%
            background-color: #fe3904
          p
            margin: 0 0 0 auto
        &:nth-child(odd) .column:last-child
          figure
            padding: 0
            margin: 1rem 0 3rem 0
            height: 4px
            width: 5%
            background-color: #fe3904
        &:nth-child(2) .column:last-child::after, &:nth-child(5) .column:first-child::after
          position: absolute
          content: ""
          top: 0
          height: 100%
          width: 70vw
          background-color: #ecf1f4
          z-index: -1
        &:nth-child(2) .column:last-child::after
          right: -100%
        &:nth-child(5) .column:first-child::after
          left: -100%
  .why
    .is-5
      padding: 0
    figure
      padding: 0 !important
      margin: 1rem 0 3rem 0
      height: 4px
      width: 100%
      background-color: #fe3904
    ul
      li
        display: flex
        align-items: center
        margin: 0 0 1.5rem 0
        span
          display: inline-block
          &:first-child
            display: inline-flex
            margin: 0 1rem 0 0
            padding: 0.2rem 0.5rem
            width: 30px
            height: 30px
            justify-content: center
            align-items: center
            color: #ffffff
            background-color: #fe3904
          &:last-child
            width: 80%

  @media screen and (max-width: 950px)
    #trades .numbers-list .columns
      height: auto
      > .grid
        width: auto
        .rich-text
          margin: 0.5rem 0
          padding: 0 0 0 4rem
</style>
